import React, { useState } from 'react';
import { Grid, Divider, Typography, TextField, Button, Avatar, createMuiTheme, ThemeProvider, InputAdornment, IconButton, CircularProgress } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles, styled, withStyles } from '@material-ui/styles';
import { Autocomplete, Box, FormControl, ListItemText, MenuItem, Select } from '@mui/material';
import { Switch, FormControlLabel, SwitchProps } from '@material-ui/core';
import { CalendarToday, CalendarTodayOutlined } from '@material-ui/icons';
import Input from '../../../Input/Input';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',

    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: 'bold',
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    informationHeading: {
        fontSize: 14,
        fontFamily: 'montserrat',
        color: '#686b72'
    },
    TypographyData: {
        fontFamily: 'montserrat',
        fontSize: 12,
        color: '#686b72',
        marginTop: 80
    },
    TypographyDataLeft: {
        fontFamily: 'montserrat',
        fontSize: 12,
        color: '#686b72',
        marginLeft: -26
    },
    TextField: {
        width: '100%',
        height: '10%'
    },
    formControl: {
        margin: theme.spacing(1),
        width: '100%',
        height: '10%',
        backgroundColor: 'white',
        borderColor: '#c3c3c3',
        borderWidth: 1,
        borderRadius: 10,
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#c3c3c3',
            },
            '&:hover fieldset': {
                borderColor: '#c3c3c3',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#c3c3c3',
            },
        },
    },
    menuItem: {
        fontSize: 12,
        fontFamily: 'montserrat',
        color: '#686b72',
    },
}));

const CustomSwitch = withStyles((theme) => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 3,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#484fdb', // Mantém a cor do círculo cinza quando marcado
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.common.white,
                borderColor: theme.palette.grey[500], // Mantém as bordas cinzas quando marcado
            },
        },
    },
    thumb: {
        width: 20,
        height: 20,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 26 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);

const Restrictions = ({
    viewEmployeeRegistration
}) => {
    const classes = useStyles()
    const [checked, setChecked] = React.useState(false);

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };
    

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Divider style={{ marginTop: -20 }} />
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={5}>
                        <div style={{ display: 'flex', marginTop: 20, marginLeft: -30 }}>
                            <CustomSwitch
                                checked={viewEmployeeRegistration.restrictions.photo}
                                onChange={event => viewEmployeeRegistration.handleChangeRestrictions(event, 'photo')}
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                            <Typography
                                style={{
                                    fontFamily: 'montserrat',
                                    fontSize: 13,
                                    marginLeft: 10,
                                    color: '#afafaf'
                                }}
                            > Exigir foto
                            </Typography>
                        </div>
                        <div style={{ display: 'flex', marginTop: 20, marginLeft: -30 }}>
                            <CustomSwitch
                                checked={viewEmployeeRegistration.restrictions.place}
                                onChange={event => viewEmployeeRegistration.handleChangeRestrictions(event, 'place')}
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                            <Typography
                                style={{
                                    fontFamily: 'montserrat',
                                    fontSize: 13,
                                    marginLeft: 10,
                                    color: '#afafaf'
                                }}
                            > Restringir local
                            </Typography>
                        </div>
                        <div style={{ display: 'flex', marginTop: 20, marginLeft: -30 }}>
                            <CustomSwitch
                                checked={viewEmployeeRegistration.restrictions.device}
                                onChange={event => viewEmployeeRegistration.handleChangeRestrictions(event, 'device')}
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                            <Typography
                                style={{
                                    fontFamily: 'montserrat',
                                    fontSize: 13,
                                    marginLeft: 10,
                                    color: '#afafaf'
                                }}
                            > Restringir dispositivo
                            </Typography>
                        </div>
                        {
                            viewEmployeeRegistration.restrictions.place ?
                                <div style={{ marginLeft: -25 }}>
                                    <Input
                                        elementType="select"
                                        value={viewEmployeeRegistration.selectedLocation}
                                        onChange={event => viewEmployeeRegistration.handleInputChangeLocation(event)}
                                        label="Local"
                                        options={viewEmployeeRegistration.locationName}
                                        margin="normal"
                                        required
                                        fullWidth
                                        
                                    />
                                </div>
                                : null
                        }




                    </Grid>
                    <Grid item xs={5}>
                        {viewEmployeeRegistration.restrictions.device || viewEmployeeRegistration.restrictions.photo || viewEmployeeRegistration.restrictions.place ?
                            <><Typography className={classes.TypographyData}>
                                Início das restrições
                            </Typography><TextField
                                    id="outlined-basic"
                                    type="date"
                                    className={classes.TextField}
                                    value={viewEmployeeRegistration.restrictions.dtFrom}
                                    onChange={event => viewEmployeeRegistration.handleChangeRestrictions(event, 'dtFrom')}
                                    variant="outlined"
                                    InputProps={{
                                        style: {
                                            ...styles.InputRight,
                                            color: '#72727a', // Define a cor do texto
                                            // Adicione aqui outros estilos necessários
                                        },
                                        inputProps: {
                                            max: "9999-12-31", // Define o valor máximo permitido
                                        },
                                    }} /></>
                            : null}
                        {
                            viewEmployeeRegistration.restrictions.device ?
                                <div style={{ marginTop: 17 }}>
                                    <Input
                                        elementType="select"
                                        value={viewEmployeeRegistration.selectedBloqueDevice}
                                        onChange={event => viewEmployeeRegistration.handleInputChangeBloquedDevice(event)}
                                        label="Aparelhos"
                                        options={viewEmployeeRegistration.listBlockedDevice}
                                        margin="normal"
                                        required
                                        fullWidth
                                    />
                                </div>
                                : null
                        }
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Divider style={{ marginTop: 30 }} />
            </Grid>
            <Grid item xs={5} />
            <Grid item xs={7} container justify="flex-end" style={{ marginLeft: -10 }}>
                {
                    viewEmployeeRegistration.loading ?
                        <CircularProgress />
                        :
                        <>
                            <Button
                                style={{
                                    ...styles.buttonOne,
                                    color: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.atualizationButton ? '#484fdb' : '#c3c3c3'
                                }}
                                onClick={() => viewEmployeeRegistration.handleClickDiscard('restrictions')}
                            >
                                Descartar atualizações
                            </Button>
                            <Button style={{
                                ...styles.buttonTwo,
                                backgroundColor: viewEmployeeRegistration.isUpdate ? '#484fdb' : viewEmployeeRegistration.atualizationButton ? '#484fdb' : 'white',
                                color: viewEmployeeRegistration.isUpdate ? 'white' : viewEmployeeRegistration.atualizationButton ? 'white' : '#c3c3c3'
                            }}
                                onClick={viewEmployeeRegistration.createdAndUpdateRestrictions}
                            >
                                Salvar
                            </Button>
                        </>
                }
                <Box style={styles.Box} />
                <Avatar style={{ ...styles.avatar }}>
                    <IconButton onClick={() => viewEmployeeRegistration.handleExpandClick('restrictions')}
                        style={{ padding: 0 }}
                    >
                        <ExpandMoreIcon style={{ fontSize: 20, color: viewEmployeeRegistration.isUpdate ? '#484fdb' : '#c3c3c3' }} />
                    </IconButton>
                </Avatar>
            </Grid>

        </Grid >
    );
};


export default Restrictions;

const styles = {
    InputLeft: {
        height: 40,
        padding: '0 14px',
        borderRadius: 10,
        marginLeft: -26
    },
    InputRight: {
        height: 40,
        padding: '0 14px',
        borderRadius: 10,
        marginRight: -25
    },
    buttonOne: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '35%',
        height: 30,
        marginLeft: -10,
        marginRight: 10,
        color: '#c3c3c3',
        fontFamily: 'montserrat',
        fontSize: 10,
        fontWeight: 'bold'
    },
    buttonTwo: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '16%',
        height: 30,
        marginRight: 10,
        color: '#c3c3c3',
        fontFamily: 'montserrat',
        fontSize: 10
    },
    Box: { borderLeft: '1px solid #c3c3c3', height: '30px', marginLeft: '10px', marginRight: 10 },
    avatar: { backgroundColor: 'white', color: '#c3c3c3', border: '1px solid #c3c3c3', width: 30, height: 30, transform: 'rotate(180deg)' }
}
